module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_72022683_XL-8270b97fef2fc5bcab793c896dc98574.jpg";